<template>
  <el-dialog title="新增假期规则" :visible.sync="updateDialog" width="1000px">
    <div style="margin:0 30px;height: 340px;overflow: auto">
      <el-form label-position="top" :model="holidayRule" :rules="rules" ref="formRef" label-width="110px" class="demo-ruleForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="规则名称" prop="name">
              <el-input v-model="holidayRule.name" style="width: 210px" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="申请条件" prop="attendanceGroupList">
              <el-select v-model="holidayRule.newStaffLeave" placeholder="请选择">
                <el-option v-for="(item,index) in dict.holidayCondition" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="是否带薪" prop="attendanceGroupList">
              <el-select v-model="holidayRule.paidLeave" placeholder="请选择">
                <el-option v-for="(item,index) in dict.isPaid" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="假期余额设置">
              <el-popover placement="left" width="320"
                          :trigger="holidayRule.balance == 1 ? 'hover' : 'focus'"
                          :key="holidayRule.balance">
                <div v-loading="holidayRule.balance == 0" element-loading-text="仅限：限制余额" style="padding: 0 10px">
                  <el-form-item label-width="100px" label="余额发放方式" prop="attendanceGroupList">
                    <el-select v-model="holidayRule.balanceGrantMethod" placeholder="请选择">
                      <el-option v-for="(item,index) in dict.holidayRemainingGrantType" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label-width="100px" label="假期有效日期" prop="attendanceGroupList">
                    <el-select v-model="holidayRule.balanceExpiry" placeholder="请选择">
                      <el-option v-for="(item,index) in dict.holidayRemainingValidityDate" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label-width="100px" label="延长有效期" prop="attendanceGroupList">
                    <button class="set-button" @click="clockTypeDialog = true">
                      <div style="margin-right: 6px">超过有效期后，假期</div>
                      <el-select style="width: 120px" size="mini" v-model="holidayRule.balanceExtend">
                        <el-option v-for="(item,index) in dict.holidayRemainingRetain" :key="index" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </button>
                  </el-form-item>
                </div>
                <template #reference>
                  <el-select  style="width: 210px" v-model="holidayRule.balance" placeholder="请选择">
                    <el-option v-for="(item,index) in dict.holidayRemaining" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-popover>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="申请单位" prop="attendanceGroupList">
              <el-select v-model="holidayRule.minLeaveUnit" placeholder="请选择">
                <el-option v-for="(item,index) in dict.applyUnit" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="100px" label="请假时长核算" prop="attendanceGroupList">
              <el-select v-model="holidayRule.calculationLeave" placeholder="请选择">
                <el-option v-for="(item,index) in dict.calculationType" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="updateDialog = false">取 消</el-button>
      <el-button type="danger" @click="updateItem">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateHolidayRule} from '/src/api/attendance/holiday'
export default {
  name: "UpdateHolidayRule",
  data() {
    return {
      updateDialog:false,
      dict:{},
      holidayRule:{
        name:"",
        balance:0,
        balanceExpiry: 0,
        balanceExtend: 0,
        balanceGrantMethod: 0,
        calculationLeave: 1,
        directorId: 0,
        minLeaveUnit: 0,
        newStaffLeave: 0,
        paidLeave: 1
      },
      rules:{
        name: [{required: true, message: "请输入名称！", trigger: "blur"}],
      },
    }
  },
  methods: {
    openDialog(dict,item) {
      this.dict = dict;
      this.holidayRule = item;
      this.updateDialog = true;
    },
    updateItem(){
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          updateHolidayRule(this.holidayRule).then(val => {
            if (val.status == 200){
              this.$emit('refresh');
              this.updateDialog = false;
              this.$message({message: '更新成功！', type: 'success'});
            }else {
              this.$message.error('更新失败！');
            }
          })
        }
      });

    }
  }
}
</script>

<style scoped>
.day-off{
  background-color: #FAFCFF;
  padding: 16px 0 0 20px;
  border-radius: 16px;
}
.set-button {
  background-color: white;
  width: 290px;
  border: #d8dbe2 1px solid;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  color: #606266;
  text-align: left;
  display: flex;
  align-items: center;
}
.set-button:hover {
  border: #c0c4cc 1px solid;
  display: flex;
  align-items: center;
}
</style>